import type React from 'react';
import { Td, Chip, Flex, Label, designTokens } from '@itandi/itandi-bb-ui';
import type { DealIndexClient, DealIndexVendor } from '~/models/Deal';
import { formatHoursAndMinutes, formatMonthAndDay } from '~/utils/DateUtil';
import { StatusIcon } from '~/components/deprecated/StatusIcon';

type Props = {
  deal: DealIndexClient | DealIndexVendor;
};

export const DealInspectionDateCell: React.FC<Props> = ({ deal }: Props) => (
  <Td textAlign="Left" verticalAlign="Top">
    <Flex alignItems="start" direction="column" gap={2}>
      {deal.inspectionBy === 'none' ? (
        <Label size="s">立会なし</Label>
      ) : (
        <>
          {deal.inspectionDate === null ? (
            <Flex>
              <Label size="s">未定</Label>
              <StatusIcon variant="Alert" />
            </Flex>
          ) : (
            <>
              <Label size="s">
                {formatMonthAndDay(deal.inspectionDate) ?? ''}
              </Label>
              <Label size="s">
                {formatHoursAndMinutes(deal.inspectionDate) ?? ''}
              </Label>
            </>
          )}
          {deal.inspectionBy === 'company' ? (
            <Chip
              background={designTokens['color/background/default/subtle']}
              borderColor={designTokens['color/neutral/9']}
              fontWeight="bold"
              label="管理"
              textColor={designTokens['color/text/subtle']}
            />
          ) : (
            <Chip
              background={designTokens['color/info-alpha/3']}
              borderColor={designTokens['color/info-alpha/10']}
              fontWeight="bold"
              label="施工"
              textColor={designTokens['color/info-alpha/11']}
            />
          )}
        </>
      )}
    </Flex>
  </Td>
);
